module.exports = __webpack_public_path__ + "img/illustration-03.d7e4056a.png";